import i18n from "../i18n";

/** Formats a byte count for display, with the unit name in the UI language. */
export const bytesToSize = (bytes : number) : string => {
    var sizes = ['unit.bytes', 'unit.kb', 'unit.mb', 'unit.gb', 'unit.tb'];
    if (bytes == 0) return `0 ${i18n.t('unit.byte')}`;
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + i18n.t(sizes[i]);
 }
